// extracted by mini-css-extract-plugin
export default {"hygiene":"HygienePage_hygiene__Hutkh"};